import "./myTasks.css"
import React, {useEffect} from "react";
import addIcon from "../header/assets/add.svg"
import {usePumpStore} from "../../store/pumpStore";
import axios from "axios";
import parse from "html-react-parser";
import {Locales} from "../../helpers/localeHelpers";


export const MyTasks = () => {
    const {myTasks, setMyTasks, appInitData, setScreenLayout, language, activeCount} = usePumpStore()


    useEffect(() => {
        axios.post('https://pump.stt.market/api/my_tasks', {'chat_id': appInitData.user.id}).then((res) => {
            setMyTasks(res.data.tasks)
        })
    }, []);

    return (
        <div className={"constructor"}>
            <p className={"constructor__text"}>{parse(Locales[language].ads)}</p>
            <h3>{activeCount}</h3>
            <p className={"constructor__text"}>{parse(Locales[language].active)}</p>
            <div className={"constructor__button"} onClick={() => setScreenLayout('createForm')}>{parse(Locales[language].create)}</div>
            <p className={"constructor__text"} style={{color: '#ffffff', fontWeight: 400, fontSize: 14}}>{parse(Locales[language].adsHelp)}</p>
            <a href={"https://t.me/kirillpoznyakov"} className={"constructor__button"} target={"_blank"} rel={"noreferrer"} style={{
                display: "block",
                fontSize: 12,
                textDecoration: "none",
                backgroundColor: '#fff3',
                boxShadow: "none"
            }}>{parse(Locales[language].adsConsult)}</a>
            <p className={"constructor__text"} style={{color: '#ffffff'}}>{parse(Locales[language].myTasks)}</p>
            <div className={"constructor__list"}>
                {myTasks.length > 0
                    ? <React.Fragment>
                        {myTasks.map((item, index) => (
                            <div className={`constructor__list-item ${item.count < item.total ? '_active' : ''}`} key={index}>
                                <div style={{width: 'calc(100% - 91px)'}}>{item.title}</div>
                                <div style={{width: 90, textAlign: "right"}}>{item.count} / {item.total}</div>
                            </div>
                        ))}
                      </React.Fragment>
                    : <p className={"constructor__text"} style={{fontWeight: 400, fontSize: 14, color: '#ffffff'}}>{parse(Locales[language].noTasks)}</p>
                }
            </div>
        </div>
    )
}